import { LitElement, html } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { appState, type AppStateData } from '../store/AppState';
import { authService } from '../services/auth';

@customElement('auth-button')
export class AuthButton extends LitElement {
  createRenderRoot() {
    return this;
  }

  @state()
  private user: AppStateData['auth']['user'] = null;

  connectedCallback() {
    super.connectedCallback();
    appState.subscribe((state: AppStateData) => {
      this.user = state.auth.user;
    });
  }

  render() {
    if (!this.user) {
      return html``;
    }

    return html`
      <div class="dropdown dropdown-end">
        <div tabindex="0" role="button" class="btn btn-ghost btn-circle avatar placeholder">
          <div class="bg-primary text-primary-content rounded-full w-10">
            <span class="text-lg">${this.getInitials()}</span>
          </div>
        </div>
        <ul tabindex="0" class="menu menu-sm dropdown-content mt-3 z-[1] p-2 shadow bg-base-100 rounded-box w-52">
          <li class="menu-title">
            <span class="font-normal text-base-content/70">${this.user.email}</span>
          </li>
          <li><button @click=${() => authService.signOut()}>Sign Out</button></li>
        </ul>
      </div>
    `;
  }

  private getInitials(): string {
    const name = this.user?.display_name || this.user?.email || '';
    const parts = name.split(/[\s@]/);
    if (parts.length >= 2) {
      return (parts[0][0] + parts[1][0]).toUpperCase();
    }
    return name.slice(0, 2).toUpperCase();
  }
}
